import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { HStack, Box, Image, Button } from "@chakra-ui/react";
import "react-loading-skeleton/dist/skeleton.css?__remix_sideEffect__";

const AccordionTaskSkeleton = ({ size, isMobile }) => {
  return (
    <Box marginLeft="8px">
      {Array.from({ length: size }).map((_, index) =>
      <HStack
        key={index}
        height={isMobile ? "32px" : "32px"}
        padding={"4px"}
        marginBottom={"4px"}>

          <SkeletonTheme color="#D3D3D3" highlightColor="#C8C8C8">
            <Box>
              <Skeleton width={"75px"} height={"30px"} count={1} />
            </Box>
            <Box>
              <Skeleton width={"75px"} height={"30px"} count={1} />
            </Box>
            <Box>
              <Skeleton width={"75px"} height={"30px"} count={1} />
              <Image src="" alt="skeleton" />
            </Box>
            <Button width={"30px"} height={"30px"} marginTop={"4px"}>
              <Skeleton width={"30px"} height={"25px"} count={1} />
            </Button>
            <Skeleton width={"30px"} height={"30px"} count={1}>
              <Image src="" alt="skeleton" />
            </Skeleton>
          </SkeletonTheme>
        </HStack>
      )}
    </Box>);

};

export default AccordionTaskSkeleton;